<template>
  <div class="toolTip" :style="position">
    <p>
      <strong>{{ name }}</strong><br>
      Suurin puolue: {{ party }}<br>
      Vastaajia:<br>
      {{ item.cand_count }} / {{ item.seats }}
    </p>
  </div>
</template>

<script>
import partyMeta from '../data/party_meta.json';
import hvaMeta from '../data/hva_meta.json';

export default {
  name: 'ToolTip',
  components: {
  },
  props: {
    item: Object,
    x: Number,
    y: Number,
  },
  data() {
    return {
      windowWidth: null,
      partyMeta,
      hvaMeta,
    }
  },
  computed: {
    party() {
      const party = this.partyMeta[this.item.biggest_party];
      return party? party[`short_name_${this.lang}`] : '';
    },
    name() {
      if (this.item.kommun_id) {
        // this is the tooltip for a muni
        return this.item[`name_${this.lang}`];
      }
      else {
        const hva = this.hvaMeta.find(m => m.id === this.item.constituency_id);
        return hva ? hva[`short_name_${this.lang}`] : this.item.constituency_id;
      }
    },
    rightAlign() {
      return 100;
    },
    position() {
      return {
        top: `${this.y + 10}px`,
        left: `${this.x - this.rightAlign}px`,
      }
    },
  },
  created() {
    this.windowWidth = window.innerWidth;
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">
.toolTip {
  position: fixed;
  background-color: #111;
  border-radius: 5px;
  padding: 8px 2px;
  pointer-events: none;
  width: 200px;
  color: #fff;
  box-sizing: border-box;
  font-size: 14px;

  p {
    font-family: 'Open Sans', sans-serif;
    color: white;
    text-align: center;
    padding: 1px;
    margin: 1px 4px 1px 4px;
    line-height: 1.3;
  }

  &:before {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #111 transparent;
    top: -20px;
    left: 90px;
  }
}
</style>